<template>
    <div class="flex flex-col content-center justify-center max-w-sm mx-auto mt-12 lg:w-full lg:max-w-md">
        <div class="flex justify-center text-4xl font-semibold text-gray-900">
            Great! You're registered, now check your email.
        </div>
        <div class="mt-12 mb-12 font-semibold text-gray-800">
            <div class="mt-2 mb-2 font-semibold text-gray-800">
                We've sent a confirmation link to <span class="text-lg font-bold">{{ email }}</span>
            </div>
        </div>
        <p class="text-sm text-gray-600">
            Don't see it yet?
            <br />
            Check your spam folder or <span @click="resend" class="font-semibold text-blue-500 cursor-pointer">send again</span>
            <span v-if="resent" class="ml-2 font-semibold">Sent!</span>
        </p>
    </div>
</template>
<script>
import api from '@/client';

export default {
    name: 'signup-email-sent',
    data() {
        return {
            resent: false,
            email: localStorage.getItem('signup_user'),
            org: localStorage.getItem('signup_org') || '',
        };
    },
    methods: {
        resend() {
            if (this.org !== '') {
                api.put('confirm/resend', { email: this.email, org_id: this.org }).then(() => (this.resent = true));
            } else {
                api.put('confirm/resend', { email: this.email }).then(() => (this.resent = true));
            }
        },
    },
};
</script>
